import React from 'react';
import { mergeClasses } from '@fluentui/react-components';

import { useAccordionContext } from '../contexts/accordion';
import { useCardContentStyles } from './card-content-styles';

interface FormCardBaseContainerProps {
  className: string;
  isCollapsable: boolean;
  open: boolean;
}

const FormCardBaseContainer: React.FC<React.PropsWithChildren<FormCardBaseContainerProps>> = ({
  className, isCollapsable, open, children,
}) => {
  const classes = useCardContentStyles();

  return (
    <div
      className={mergeClasses(
        className,
        classes.container,
        !isCollapsable && classes.uncollapsableContainer,
        !open && classes.hidden,
      )}
      // @ts-ignore
      inert={open ? undefined : ''}
      aria-hidden={open ? 'false' : 'true'}
    >
      <div className={mergeClasses('content', classes.content, !open && classes.contentHidden)}>
        {children}
      </div>
    </div>
  );
};

export const FormCardBody: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const accordionContext = useAccordionContext();

  return (
    <FormCardBaseContainer
      className="card-body"
      isCollapsable={!!accordionContext}
      open={accordionContext ? accordionContext.open : true}
    >
      {children}
    </FormCardBaseContainer>
  );
};

export const FormCardSummary: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const collapseContext = useAccordionContext();

  return (
    <FormCardBaseContainer
      className="card-summary"
      isCollapsable={!!collapseContext}
      open={collapseContext ? !collapseContext.open : false}
    >
      {children}
    </FormCardBaseContainer>
  );
};
